export default "__VITE_ASSET__160a537d__"